define('Stock.Status.View', [
    'stock_status_view.tpl',
    'Backbone.CompositeView',
    'SC.Configuration',
    'Backbone',
    'underscore',
    'jQuery'
], function StockStatusView(
    StockStatusTpl,
    BackboneCompositeView,
    Configuration,
    Backbone,
    _,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        template: StockStatusTpl || function emptyTpl() { return true; },

        initialize: function initialize(options) {
            this.model = options.model;
            this.stockResults = {};
            this.pdp = options.pdp;
            this.multipleStock = Configuration.get('customizations.stockStatus.multipleIds');
            BackboneCompositeView.add(this);
            this.model.on('change', this.render, this);
        },

        render: function render() {
            this._render();
        },

        getStatusName: function getStatusName(code) {
            var iaInfo = _.findWhere(SC.ENVIRONMENT.published.IaMessage, { code: code.toString() });

            return _.translate(iaInfo ? iaInfo.message : 'No status available');
        },

        multipleStockStatus: function multipleStockStatusFunction(model) {
            var itemId;
            var actualQty;
            var iaSelected;
            var stockQty;
            var outOfStockMsg = Configuration.get('customizations.stockStatus.outOfStockCustomMsg');
            if (this.multipleStock && _.size(model) > 0 && !model.itemRecord) {
                if (this.pdp.getSelectedMatrixChilds() && this.pdp.getSelectedMatrixChilds().length > 0) {
                    // Check if the item have corresponding SKU
                    if (_.first(this.pdp.getSelectedMatrixChilds()).custitem_corresponding_sku_num_id) {
                        itemId = _.first(this.pdp.getSelectedMatrixChilds()).custitem_corresponding_sku_num_id;
                    } else {
                        itemId = _.first(this.pdp.getSelectedMatrixChilds()).internalid;
                    }
                } else {
                    itemId = _.first(model).item;
                }
                actualQty = this.pdp && this.pdp.getItemInfo() && this.pdp.getItemInfo().quantity;
                if (_.size(model) > 0) {
                    iaSelected = _.findWhere(model, { item: itemId.toString() });
                    if (!iaSelected) {
                        iaSelected = _.findWhere(model, { item: itemId });
                    }
                    stockQty = iaSelected ? iaSelected.quantity : 0;
                    if (stockQty === 0) {
                        this.stockResults.iaStatus = outOfStockMsg;
                    } else if (stockQty >= actualQty) {
                        if (iaSelected && iaSelected.statusId !== 4) {
                            this.stockResults.iaStatus = this.getStatusName(iaSelected.statusId);
                            if (iaSelected && iaSelected.statusId && iaSelected.statusId === '2' && iaSelected.date && iaSelected.date !== '') {
                                this.stockResults.iaDate = iaSelected.date;
                            }
                            if (iaSelected && iaSelected.statusId && iaSelected.statusId === '3' && iaSelected.date && iaSelected.date !== '') {
                                this.stockResults.iaDate = iaSelected.date;
                            }
                            if (iaSelected && iaSelected.statusId && iaSelected.statusId === '5' && iaSelected.date && iaSelected.date !== '') {
                                this.stockResults.iaDate = iaSelected.date;
                                this.stockResults.endDate = iaSelected.endDate;
                                this.stockResults.substatusId = iaSelected.substatusId;
                            }
                        } else {
                            this.stockResults.iaStatus = outOfStockMsg;
                        }
                    } else {
                        this.stockResults.iaStatus = 'Quantity not Available';
                    }
                    if (this.pdp.getSelectedMatrixChilds() && this.pdp.getSelectedMatrixChilds().length > 0 && this.pdp.getSelectedMatrixChilds().length !== 1) {
                        this.stockResults.iaStatus = '';
                    }
                    if (!iaSelected) {
                        this.stockResults.iaStatus = '';
                        this.stockResults.iaStatusId = '';
                    }
                    this.stockResults.iaStatusId = iaSelected && iaSelected.statusId;
                    return this.stockResults;
                }
            } else {
                this.stockResults.iaStatus = model.statusId ? this.getStatusName(model.statusId) : '';
                this.stockResults.iaDate = model.date ? model.date : '';
                return this.stockResults;
            }
            return false;
        },

        singleStockStatus: function singleStockStatusFunction(model) {
            var iaSelected;
            if (_.size(model) > 2) {
                iaSelected = _.filter(SC.ENVIRONMENT.published.IaMessage, function filterMessage(message) {
                    return message.code === model.statusId;
                });
                if (model.statusId && model.statusId === '2') {
                    this.stockResults.iaDate = model.date;
                }
                if (model.statusId && model.statusId === '3') {
                    this.stockResults.iaDate = model.date;
                }
                if (model.statusId && model.statusId === '4') {
                    this.stockResults.iaStatus = 'Unavailable Online';
                } else {
                    this.stockResults.iaStatus = _.first(iaSelected) ? _.first(iaSelected).message : null;
                }
                this.stockResults.iaStatusId = _.first(iaSelected) ? _.first(iaSelected).code : null;
                return this.stockResults;
            }
            return false;
        },

        getContext: function getContext() {
            var results = {};
            var showErrorQty = this.model.get('showErrorQty');
            var freeShipping;
            var freeShippingText = 'Free Shipping';
            if (_.size(this.model.attributes) > 0) {
                if (this.multipleStock) {
                    results = this.multipleStockStatus(this.model.attributes);
                    freeShipping = results && parseInt(results.substatusId, 10) === 1;
                } else {
                    results = this.singleStockStatus(this.model.attributes);
                    freeShipping = parseInt(this.model.attributes.substatusId, 10) === 1;
                }
            }
            return {
                status: results ? results.iaStatus : null,
                statusId: results ? results.iaStatusId : null,
                date: results ? results.iaDate : null,
                showErrorQty: showErrorQty,
                freeShipping: freeShipping,
                freeShippingText: freeShippingText,
                endDate: results ? results.iaDate : null,
                substatusId: results ? results.substatusId : null
            };
        }
    });
});

